import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const MEDIA = `${BACKEND_URL}/api/media`;

// Public axios (no credentials — uses cookies if present but not required)
export const api = axios.create({
  baseURL: API,
  timeout: 20000,
  withCredentials: true,
});

// Admin axios — sends cookies AND falls back to Bearer token in localStorage
export const adminApi = axios.create({
  baseURL: API,
  timeout: 30000,
  withCredentials: true,
});

const TOKEN_KEY = "salihi_admin_token";

export function saveAdminToken(token) {
  try {
    localStorage.setItem(TOKEN_KEY, token);
  } catch (_e) {
    /* ignore */
  }
}

export function clearAdminToken() {
  try {
    localStorage.removeItem(TOKEN_KEY);
  } catch (_e) {
    /* ignore */
  }
}

export function getAdminToken() {
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch (_e) {
    return null;
  }
}

adminApi.interceptors.request.use((config) => {
  const token = getAdminToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});
